<template>
  <!--车源信息 -->
  <div class="layout">
    <Layout>
      <!-- 头 -->
      <Header>
        <Menu theme="light" mode="horizontal" active-name="2">
          <div class="layout-logo">
            <a href="/"> <img src="../assets/logo-title-v3.png" alt="" /></a>
          </div>
          <div class="layout-nav">
            <!-- <MenuItem style="font-size: 18px !important" name="1" to="/sourceInformation">
            aa信息
            </MenuItem>
            <MenuItem to="/vehicleInformation" style="font-size: 18px !important" name="2">
            bb信息
            </MenuItem> -->
            <MenuItem to="/complaintPublicity" style="font-size: 18px !important" name="3">
            评价公示
            </MenuItem>
            <MenuItem to="/evaluationPublicity" style="font-size: 18px !important" name="4">
            投诉公示
            </MenuItem>
            <Submenu name="5">
              <template slot="title"><span style="font-size: 18px !important">联系客服</span>
              </template>
              <MenuItem to="/customerServiceContact" style="
                  font-size: 15px !important;
                  padding-left: 35px !important;
                " name="2-1">投诉建议</MenuItem>
              <MenuItem to="/contactUs" style="
                  font-size: 15px !important;
                  padding-left: 35px !important;
                " name="2-2">联系我们</MenuItem>
            </Submenu>
          </div>
        </Menu>
      </Header>
      <div class="Header-img"></div>
      <!-- 中 -->
      <Content>
        <div style="display: flex; justify-content: center">
          <div></div>
          <div>
            <div class="search">
              <div style="display: flex">
                <div style="color: #333; font-size: 16px" class="Content-criteria" @click="clickCriteriaIcon">
                  车辆类型
                  <i :class="
                      criteriaIcon == true
                        ? 'el-icon-caret-top'
                        : 'el-icon-caret-bottom'
                    "></i>
                </div>
              </div>
            </div>
            <div v-if="!criteriaIcon" class="search2">
              <div>
                <el-button style="
                    width: 75px;
                    height: 40px;
                    margin-top: 10px;
                    margin-left: 10px;
                  " :class="item.isSelected ? 'Active' : ''" v-for="(item, index) in list"
                  @click="cutTabClick(index, item)" :key="index">{{ item.name }}</el-button>
              </div>
            </div>
            <div v-if="!criteriaIcon" class="search-but">
              <div style="display: flex; justify-content: space-between">
                <div></div>
                <div>
                  <el-button size="large" style="
                      background-color: #19be6b !important;
                      color: #fff !important;
                      border: 0 !important;
                    " :loading="butLoading" @click="queryVehicleType">确定</el-button>
                </div>
              </div>
            </div>
          </div>
          <div></div>
        </div>
        <!--  -->
        <div style="margin: 40px 0"></div>
        <!--  -->
        <div style="
            display: flex;
            justify-content: center;
            margin-bottom: 40px;
            margin-left: 58px;
          ">
          <div></div>
          <div class="Content-tblo">
            <div></div>
            <div class="Vehicle-information-css">
              <div class="vehicle-list" v-for="(item, index) in vehicleData.records" :key="index">
                <div>
                  <img class="vehicle-icon" src="../assets/icon2.png" alt="" />
                </div>
                <div class="licensePlate">{{ item.vehicleNum }}</div>
                <div style="display: flex">
                  <div>
                    <i class="el-icon-user-solid vehicle-name-icon"></i>
                  </div>
                  <div class="vehicle-name">
                    {{ item.driverName | vehicleName }}
                  </div>
                </div>
                <div style="display: flex">
                  <div>
                    <Icon class="vehicle-phone-icon" type="ios-call" />
                  </div>
                  <div class="vehicle-Phone">{{ item.phone }}</div>
                </div>
                <div class="Linx"></div>
                <div>
                  <div style="
                      font-size: 16px;
                      color: #666666;
                      margin-bottom: 5px;
                      display: flex;
                    ">
                    <!-- 车型车长：13米/平板 -->
                    车型车长：{{ item.vehicleType | VehicleType }} /
                    {{ item.vehicleLength | vehicleLength }}
                  </div>
                  <div style="
                      font-size: 16px;
                      color: #666666;
                      margin-bottom: 15px;
                      display: flex;
                    ">
                    车辆载重：{{ item.approvedLoad }} 吨
                  </div>
                </div>
              </div>
            </div>
            <!-- <div style="width: 94.5%; margin-top: 10px" class="block">
              <div class="page-css">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage4"
                  :page-sizes="[10, 50, 100, 200]"
                  :page-size="this.vehicleData.size"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="this.vehicleData.total"
                >
                </el-pagination>
              </div>
            </div> -->
          </div>
          <div></div>
        </div>
      </Content>
      <!-- 尾 -->
      <Footer class="layout-footer-center">
        <div style="
            width: 100%;
            height: 100%;
            background-image: linear-gradient(#252c37, #1e252c);
          ">
          <div style="width: 100%; height: 50px"></div>
          <!-- 低 -->
          <div style="display: flex">
            <div class="Footer-text-left">仓鼠潮玩欢迎您的加入！</div>
            <div class="Footer-text-right">
              <p class="Footer-text-title">武汉仓鼠科技有限公司</p>
              <!-- <p class="opt opt-let">
                <span class="title">帮助中心</span>
                <router-link class="a-link" :to="'/userGuide'">
                  用户指南
                </router-link>
              </p> -->
              <!-- <p class="opt opt-let">
                <span class="title">关于我们</span>
                <router-link class="a-link" :to="'/contactUs'">
                  联系我们
                </router-link>
              </p> -->
              <p class="opt opt-let2">
                <span style="margin-left: -1px" class="title">服务热线</span>
                <router-link class="a-link1" :to="'#'">
                  13168007462
                </router-link>
              </p>
            </div>
          </div>
          <!-- 线 -->
          <div class="Line">
            <div class="LineClik"></div>
          </div>
          <!-- 低 -->
          <div>
            <!-- <p style="line-height: 18px">
              <img src="../assets/hui.png" style="width: 18px; height: 18px; vertical-align: middle" alt="" />
              <a style="line-height: 18px; color: #ffffff"
                href="http://www.beian.gov.cn/portal/recordQuery?token=cc5dd992-aa8e-47e8-94b8-2c2e2feadf98"
                target="_blank">豫公网安备：41080039010-21001号</a>&emsp;
              <span style="color: #b4c1cd">增值电信业务经营许可证：</span>
              <a href="https://beian.miit.gov.cn/#/Integrated/index" style="line-height: 18px; color: #ffffff"
                target="_blank">豫B2-20210727</a>
            </p> -->
            <p style="padding-bottom: 20px; color: #b4c1cd">
              <!-- © Copyright 2020-2023 -->
              <span><a style="color: #ffffff" href="#">
                  武汉仓鼠科技有限公司
                </a></span><br />
              All Rights Reserved.
              <a style="color: #ffffff" href="https://beian.miit.gov.cn/#/Integrated/index"
                target="_blank">鄂ICP备2024065508号-1</a>
            </p>
            <div>
              <div style="width: 100%; height: 10px"></div>
            </div>
          </div>
        </div>
      </Footer>
    </Layout>
  </div>
</template>
<script>
export default {
  data() {
    return {
      value1: 0,
      height: 0,
      one: false,
      criteriaIcon: true,
      checkboxLst: [],
      cities: ["上海", "北京", "广州", "深圳"],
      list: [
        { name: "4.2米", isSelected: false, value: "4" },
        { name: "5米", isSelected: false, value: "5" },
        { name: "6.2米", isSelected: false, value: "6" },
        { name: "6.8米", isSelected: false, value: "7" },
        { name: "7.7米", isSelected: false, value: "8" },
        { name: "8.2米", isSelected: false, value: "9" },
        { name: "8.7米", isSelected: false, value: "10" },
        { name: "9.6米", isSelected: false, value: "11" },
        { name: "11.7米", isSelected: false, value: "12" },
        { name: "12.5米", isSelected: false, value: "13" },
        { name: "13米", isSelected: false, value: "14" },
        { name: "13.7米", isSelected: false, value: "15" },
        { name: "15米", isSelected: false, value: "16" },
        { name: "16米", isSelected: false, value: "17" },
        { name: "17.5米", isSelected: false, value: "18" },
      ],
      vehicle_typeList: [
        {
          name: "平板",
          value: "1",
        },
        {
          name: "高栏",
          value: "2",
        },
        {
          name: "厢式",
          value: "3",
        },
        {
          name: "集装箱",
          value: "4",
        },
        {
          name: "自卸",
          value: "5",
        },
        {
          name: "冷藏",
          value: "6",
        },
        {
          name: "保温",
          value: "7",
        },
        {
          name: "高低板",
          value: "8",
        },
        {
          name: "面包车",
          value: "9",
        },
        {
          name: "棉被车",
          value: "10",
        },
        {
          name: "爬梯车",
          value: "11",
        },
        {
          name: "飞翼车",
          value: "12",
        },
        {
          name: "依维柯",
          value: "13",
        },
      ],
      actiove: 0,
      phone: "",
      currentPage4: 1,
      searchForm: {
        pageNumber: 1,
        pageSize: 12,
        sort: "",
        order: "",
        vehicleLength: "",
      },
      vehicleData: {
           records: [
             {
                vehicleNum:'平板',
          driverName:'张00',
          phone:'18595428132',
          approvedLoad:'10',
          vehicleType:'1',
             },
              {
                vehicleNum:'高栏',
          driverName:'李00',
          phone:'17610312637',
          approvedLoad:'15',
          vehicleType:'2',
             },
              {
                vehicleNum:'厢式',
          driverName:'董00',
          phone:'18538064456',
          approvedLoad:'20',
          vehicleType:'3',
             },
              {
                vehicleNum:'集装箱',
          driverName:'马00',
          phone:'18992857680',
          approvedLoad:'10',
          vehicleType:'4',
             },
             
        ]
      },
      butLoading: false,
    };
  },
  filters: {
    vehicleName: function (value) {
      if (value) {
        if (value.length > 3) {
          let text1 = value.substring(0, 1);
          return `${text1}**`;
        } else if (value.length == 3) {
          let text1 = value.substring(0, 1);
          return `${text1}**`;
        } else {
          let text1 = value.substring(0, 1);
          return `${text1}*`;
        }
      }
    },
    VehicleType: function (value) {
      let txet = "";

      let list = [
        {
          name: "平板",
          value: "1",
        },
        {
          name: "高栏",
          value: "2",
        },
        {
          name: "厢式",
          value: "3",
        },
        {
          name: "集装箱",
          value: "4",
        },
        {
          name: "自卸",
          value: "5",
        },
        {
          name: "冷藏",
          value: "6",
        },
        {
          name: "保温",
          value: "7",
        },
        {
          name: "高低板",
          value: "8",
        },
        {
          name: "面包车",
          value: "9",
        },
        {
          name: "棉被车",
          value: "10",
        },
        {
          name: "爬梯车",
          value: "11",
        },
        {
          name: "飞翼车",
          value: "12",
        },
        {
          name: "依维柯",
          value: "13",
        },
      ];
      if (value) {
        list.forEach((item) => {
          if (item.value == value) {
            txet = item.name;
          }
        });
        return txet;
      }
    },
    vehicleLength: function (value) {
      let txet = "";
      let list = [
        { name: "4.2米", isSelected: false, value: "4" },
        { name: "5米", isSelected: false, value: "5" },
        { name: "6.2米", isSelected: false, value: "6" },
        { name: "6.8米", isSelected: false, value: "7" },
        { name: "7.7米", isSelected: false, value: "8" },
        { name: "8.2米", isSelected: false, value: "9" },
        { name: "8.7米", isSelected: false, value: "10" },
        { name: "9.6米", isSelected: false, value: "11" },
        { name: "11.7米", isSelected: false, value: "12" },
        { name: "12.5米", isSelected: false, value: "13" },
        { name: "13米", isSelected: false, value: "14" },
        { name: "13.7米", isSelected: false, value: "15" },
        { name: "15米", isSelected: false, value: "16" },
        { name: "16米", isSelected: false, value: "17" },
        { name: "17.5米", isSelected: false, value: "18" },
      ];
      list.forEach((item) => {
        if (item.value == value) {
          txet = item.name;
        }
      });
      return txet;
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.$axios({
        method: "post",
        url: "/freight/officialWebsiteData/vehicleManagementList",
        data: this.searchForm,
        transformRequest: [
          function (data) {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            ret = ret.substring(0, ret.length - 1);
            return ret;
          },
        ],
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }).then((res) => {
        this.vehicleData = res.data.result;
        this.vehicleData.records.forEach((item) => {
          item.phone = this.intercept(item.driverPhone);
          item.approvedLoad = item.approvedLoad 
        });
      });
    },
    // 截取
    intercept(val) {
      if (val != null) {
        if (val.length >= 10) {
          let text1 = val.substring(0, 3);
          let text2 = val.substring(10);
          return `${text1}*****${text2}`;
        } else {
          return val;
        }
      } else {
        return (val = "");
      }
    },
    // 车辆类型
    clickCriteriaIcon() {
      this.criteriaIcon = !this.criteriaIcon;
    },
    // 车辆类型选择
    cutTabClick(index, item) {
      this.actiove = index;
      this.checkboxLst.push(item);
      //然后通过这个属性判断是否选中点亮和取消
      item.isSelected = !item.isSelected;
      this.list.forEach((items) => {
        if (item.isSelected == items) {
        }
      });
    },
    //车辆类型 确定
    queryVehicleType() {
      this.butLoading = true;
      let arr = [];
      this.checkboxLst = [...new Set(this.checkboxLst)];
      this.checkboxLst.forEach((item) => {
        if (item.isSelected == true) {
          arr.push(item.value);
        }
      });
      this.searchForm.vehicleLength = arr.join(",");
      this.init();
      setTimeout(() => {
        this.butLoading = false;
      }, 600);
    },
    handleSizeChange(val) {
      this.searchForm.pageSize = val;
      this.init();
    },
    handleCurrentChange(val) {
      this.searchForm.pageNumber = val;
      this.init();
    },
  },
};
</script>
<style scoped >
/* .ivu-select-dropdown {
  margin-top: -10px !important;
} */
.Header-img {
  background-image: url("../assets/sourceInformation.png");
  width: 100%;
  height: 232px;
}
.search {
  width: 1175px;
  background-color: #ffffff;
  margin-top: 40px;
  padding: 30px;
}
.search2 {
  border-top: 1px solid #f1f1f1;
  background-color: #ffffff;
  box-sizing: border-box;
  padding: 30px;
  width: 1175px;
}
.search-but {
  background-color: #ffffff;
  box-sizing: border-box;
  padding: 30px;
  width: 1175px;
  padding-top: 2px;
}
.Content-criteria {
  /* margin-left: 100px; */
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  color: #cccccc;
  cursor: pointer;
  transition: 0s;
}
.Content-tblo {
  width: 1230px;
  /* background-color: #ffffff; */
  text-align: center;
  height: 1340px;
  overflow: auto;
}
.Active {
  /* background: #fd7522;
  border: 1px solid #fd7522;
  color: #fff; */
  background-color: #19be6b !important;
  color: #fff !important;
  border: 0 !important;
  width: 75px;
  height: 40px;
  margin-top: 10px;
}
.Vehicle-information-css {
  display: flex;
  flex-wrap: wrap;
}
.page-css {
  height: 55px;
  padding-top: 12px;
  background-color: #fff;
  border-radius: 5px;
}

/* 按钮鼠标经过的颜色 */
/* .el-button:focus,
.el-button:hover {
  border: 1px solid #dcdfe6;
  color: #606266;
  border-color: #fff; 
 background-color: #fd7522;
} */
.vehicle-list {
  width: 276px;
  box-shadow: 0px 5px 5px #e7edf4;
  display: inline-block;
  background-color: #ffffff;
  padding: 0px 17px;
  position: relative;
  margin: 0px 20px 20px 0px;
  box-sizing: border-box;
}
.vehicle-icon {
  display: block;
  width: 96px;
  height: 96px;
  margin: 24px auto;
}
.licensePlate {
  font-size: 24px;
  margin: 0px auto;
  padding: 8px 8px;
  font-weight: 700;
  background-color: #ffb933;
  border: solid #4a4a4a 1px;
  border-radius: 5px;
  display: inline-block;
}
.licensePlate-blue {
  font-size: 24px;
  margin: 0px auto;
  padding: 8px 8px;
  font-weight: 700;
  background-color: #1e90ff;
  border: solid #1e90ff 1px;
  border-radius: 5px;
  display: inline-block;
  color: #fff;
}
.vehicle-name {
  margin-top: 20px;
  font-size: 22px;
  display: flex;
}
.vehicle-name-icon {
  color: #dddddd;
  font-size: 22px;
  margin-top: 25px;
  margin-right: 8px;
  margin-bottom: 10px;
}
.vehicle-phone-icon {
  color: #dddddd;
  font-size: 25px;
  margin-right: 5px;
  margin-top: 5px;
  margin-bottom: 10px;
}
.vehicle-Phone {
  font-size: 22px;
  color: #f88b49;
  display: flex;
}
.Linx {
  height: 1px;
  background-color: #efefef;
  margin: 20px 0;
}

/*     000000000000000000000000 */
.ivu-layout-header {
  padding: 0 !important;
  height: 89px !important;
  background: #fff !important;
  box-shadow: 0px 3px 7px 0px rgb(0 0 0 / 19%) !important;
}
.ivu-menu-horizontal {
  height: 89px !important;
  line-height: 89px !important;
  background: #fff !important;
  box-shadow: 0px 3px 7px 0px rgb(0 0 0 / 19%) !important;
}
.layout {
  /* border: 1px solid #d7dde4; */
  background: #f5f7f9;
  position: relative;
  border-radius: 4px;
  /* overflow: hidden; */
}
.ivu-layout-footer {
  padding: 0 !important;
}
.layout-logo {
  width: 100px;
  height: 30px;
  /* background: #5b6270; */
  border-radius: 3px;
  float: left;
  position: relative;
  top: 30px;
  left: 30px;
}
.layout-logo img {
  height: 44px;
  position: relative;
  top: -13px;
  left: 50px;
}

.layout-nav {
  width: 650px;
  margin: 0 auto;
  margin-right: 20px;
}
.layout-footer-center {
  text-align: center;
}

.Footer-text-left {
  font-size: 40px;
  color: #065fc3;
  display: inline-block;
  font-style: italic;
  margin-left: 23%;
  margin-top: 45px;
}
.Footer-text-right {
  width: 321px;
  display: inline-block;
  margin-left: 96px;
  /* color: #ffffff;
  position: absolute;
  top: 50%;
  transform: translateY(-50%); */
}
.Footer-text-title {
  font-size: 22px;
  margin-bottom: 10px;
  color: #fff;
}
.opt {
  line-height: 2.2;
}
.opt-let {
  margin-left: -79px;
}
.opt-let2 {
  width: 400px;
  margin-left: -59px;
  display: inline-block;
}

.title {
  font-size: 16px;
  color: #b4c1cd;
  border-right: 1px #b4c1cd solid;
  padding-right: 15px;
}
.a-link {
  font-size: 16px;
  color: #ffffff;
  margin-left: 15px;
}
.a-link1 {
  font-size: 16px;
  color: #ffffff;
  margin-left: 14px;
}
.Line {
  margin-top: 40px;
  margin-bottom: 40px;
  /* border-bottom: 1px solid #fff; */
  z-index: 9999;
}
.LineClik {
  position: relative;
  bottom: 0px;
  left: 1px;
  width: 99.5%;
  height: 1px;
  background-color: #3f4955;
}
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-item-active,
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-item:hover,
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu-active,
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu:hover {
  color: rgb(33, 195, 143);
  border: 0;
}
</style>


// WEBPACK FOOTER //
// src/pages/vehicleInformation.vue